import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bloomsburgConfig } from "./data";

export default function BloomsburgPage() {
  return <CityPageTemplate config={bloomsburgConfig} />;
}